var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconManagerStatistics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.3532 2.01562V14.0156H1.64681V2.01562H16.3532ZM17.5021 0.609375C17.1702 0.203125 16.7872 0 16.3532 0H1.64681C1.18723 0 0.791489 0.203125 0.459574 0.609375C0.153191 0.984375 0 1.45312 0 2.01562V14.0156C0 14.5469 0.153191 15.0156 0.459574 15.4219C0.791489 15.7969 1.18723 15.9844 1.64681 15.9844H5.74468V18H12.2553V15.9844H16.3532C16.7872 15.9844 17.1574 15.7969 17.4638 15.4219C17.7957 15.0156 17.9617 14.5469 17.9617 14.0156L18 2.01562C18 1.45312 17.834 0.984375 17.5021 0.609375ZM14 5H10.6948L11.9601 6.26526L9.27465 8.9507L7.07981 6.75587L3 10.8357L3.77465 11.6103L7.07981 8.30516L9.27465 10.5L12.7347 7.03991L14 8.30516V5Z",
    fill: "#222222"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconManagerStatistics);
export default __webpack_public_path__ + "static/media/icon-manager-statistics.512242858278be65797879ef93c35929.svg";
export { ForwardRef as ReactComponent };